import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rnzbyn79fg: FaireBrandEntity = {
  token: "b_rnzbyn79fg",
  type: "brand",
  name: "Ember Water",
  avatarUrl:
    "https://cdn.faire.com/fastly/6ac4d1185481fbaa75406a3713d085a7a63912e10c144ff7ed532b53cd859f6a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d2191b4725e508ea901a7d86c74df2e6faf9da7e2093d399e725a0650c3190f8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6ac4d1185481fbaa75406a3713d085a7a63912e10c144ff7ed532b53cd859f6a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d2191b4725e508ea901a7d86c74df2e6faf9da7e2093d399e725a0650c3190f8.png",
  location: "Dyersburg, TN, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 140,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 2021 by Alicia Gill and her husband, Ryan Gill. Our business started with a simple passion for crafting quality, safe products. What began as a small venture selling handmade candles and wax melts at the local farmer’s market has grown into a full line of home, body, pet, and auto products. Operating out of a 1000 sq ft candle workshop in the basement of our home, we are proud to offer fragrances that are not only skin-safe and clean-burning but also safe for children, families, and pets.\n\nEvery item is handmade with care, reflecting our commitment to creating products that smell wonderful, long lasting, and are safe for everyday use. We believe in providing our  customers with peace of mind, knowing that what they bring into their homes is free from harmful chemicals and poses no health risk. Thank you for supporting our journey and helping us turn a small idea into a thriving business.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.670Z",
    importedBy: "entity-db-cli",
  },
};
